import { render, staticRenderFns } from "./EditInformationsProfile.vue?vue&type=template&id=0c191eb8&lang=pug&"
import script from "./EditInformationsProfile.vue?vue&type=script&lang=ts&"
export * from "./EditInformationsProfile.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports